export const anyLoading = (...args: Array<{ loading: boolean, error?: { message: string } }>) => {
  const loading = args.some((item) => item.loading);

  let errors: string[] | null = args.reduce((itemErrors: string[], item) => {
    if(!item.error) return itemErrors;
    return [...itemErrors, item.error.message.replace('GraphQL error: ','')]
  }, []);

  errors = (errors.length)? errors : null;
  return {loading, errors};
};

export default anyLoading;